import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL!;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY!;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. Please check your .env file.'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// Database types
export interface Branch {
  id: string;
  name: string;
  description?: string;
  created_at?: string;
  updated_at?: string;
}

export interface Brand {
  id: string;
  name: string;
  description?: string;
  created_at?: string;
  updated_at?: string;
}

export interface Category {
  id: string;
  name: string;
  description?: string;
  color: string;
  created_at?: string;
  updated_at?: string;
}

export interface Dress {
  id: string;
  brand_id?: string;
  name: string;
  description?: string;
  category_id?: string;
  color: string;
  size: string;
  rental_price: number;
  barcode: string;
  photo_url?: string;
  is_available?: boolean;
  created_at?: string;
  updated_at?: string;
  branch_id?: string;
  brands?: Brand;
  categories?: Category;
  branches?: Branch;
}

export interface Customer {
  id: string;
  name: string;
  email?: string;
  phone?: string;
  address?: string;
  created_at?: string;
  updated_at?: string;
}

export interface Rental {
  id: string;
  dress_id?: string;
  customer_id?: string;
  rental_date: string;
  return_date?: string;
  expected_return_date: string;
  rental_price: number;
  deposit_amount?: number;
  status?: 'active' | 'returned' | 'overdue' | 'cancelled';
  location?: string;
  alterations?: 'CLIENT' | 'DMU' | null;
  notes?: string;
  customer_signature?: string | null;
  shop_signature?: string | null;
  created_at?: string;
  updated_at?: string;
  dresses?: Dress;
  customers?: Customer;
} 